<template>
  <div
    v-on-clickaway="away"
    :class="{
      'f-dropdown': true,
      'f-dropdown-minimal': theme === 'minimal',
      'is-open': dropdownOpen,
      'f-dropdown-with-avatar': type === 'with-avatar'
    }">
    <f-button
      class="f-dropdown-toggle"
      theme="inverted"
      ref="toggleBtn">
      <template v-if="type === 'attachment'">
        <f-icon name="attachment" />
      </template>
      <template v-else-if="type === 'more'">
        <f-icon name="more" />
      </template>
      <template v-else-if="type === 'with-avatar' && imgSrc.length">
        <img
          class="f-dropdown-img"
          :src="imgSrc"
          :alt="$t('user.userAvatar')" />
      </template>
      <span class="text">{{ text }}</span>
    </f-button>
    <transition name="fade">
      <div
        class="f-dropdown-content"
        ref="dropdownContent">

        <template v-for="(item, itemIndex) in items">
          <a
            v-if="item.type === 'link'"
            :key="itemIndex"
            :href="item.href"
            :class="{
              'lnk': true,
              'f-dropdown-item': true,
              'danger': item.theme === 'danger'
            }">
            {{ item.label }}
          </a>
          <router-link
            v-if="item.type === 'router-link'"
            :key="itemIndex"
            :to="item.to"
            :class="{
              'lnk': true,
              'f-dropdown-item': true,
              'danger': item.theme === 'danger'
            }">
            {{ item.label }}
          </router-link>
          <f-button
            v-if="item.type === 'button'"
            :key="itemIndex"
            :disabled="item.disabled ? item.disabled : false"
            @click.prevent="emitEvent(item)"
            :class="{
              'f-dropdown-item': true,
              'danger': item.theme === 'danger'
            }">
            {{ item.label }}
          </f-button>
        </template>
      </div>

    </transition>
  </div>
</template>
<script>

import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'f-dropdown',
  mixins: [clickaway],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'minimal'].includes(v)
    },
    type: {
      type: String,
      default: '',
      validator: v => ['attachment', 'more', 'with-avatar', ''].includes(v)
    },
    imgSrc: {
      type: String
    }
  },
  data () {
    return {
      dropdownOpen: false
    };
  },
  mounted () {
    this.$el.addEventListener('click', this.toggleDropdown);
  },
  methods: {
    toggleDropdown (e) {
      e.preventDefault();
      this.dropdownOpen = !this.dropdownOpen;
    },
    away () {
      this.dropdownOpen = false;
    },
    emitEvent (item) {
      this.dropdownOpen = false;
      this.$bus.$emit(item.event, item.param)
    }
  },
  beforeDestroy () {
    this.$el.addEventListener('click', this.toggleDropdown);
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
